import { createClient, SupabaseClient } from "@supabase/supabase-js";

const REACT_APP_ENV = process.env.REACT_APP_ENV;
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://fhgidcjliheaxdlzfmbx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZoZ2lkY2psaWhlYXhkbHpmbWJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0OTA0NjUsImV4cCI6MjA1NTA2NjQ2NX0.g7y-wJ3WDC0liQC741Hoc27aaAUsni7GxSjXqIivEP8';

// console.log("REACT_APP_ENV", REACT_APP_ENV);
// console.log("process.env.REACT_APP_SUPABASE_URL", process.env.REACT_APP_SUPABASE_URL);
// console.log("process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY", process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY);
// console.log("SUPABASE_URL", SUPABASE_URL);
// console.log("SUPABASE_PUBLISHABLE_KEY", SUPABASE_PUBLISHABLE_KEY);

type allowedContentType = "application/pdf" | "application/json";
class SupabaseService {
    private static instance: SupabaseClient;

    public constructor() { }

    public static getInstance(): SupabaseClient {
        if (!SupabaseService.instance) {
            SupabaseService.instance = createClient(
                SUPABASE_URL,
                SUPABASE_PUBLISHABLE_KEY,
            );
        }
        return SupabaseService.instance;
    }

    // Function to upload ArrayBuffer to Supabase Storage
    public uploadBlobToSupabase = async (
        blob: Blob,
        bucketName: string,
        filePath: string,
        contentType: allowedContentType = "application/pdf",
    ): Promise<{ success: boolean; data?: any; error?: any }> => {
        // Convert ArrayBuffer to Blob with appropriate content type
        //const blob = new Blob([arrayBuffer], { type: contentType });

        // Upload the blob to Supabase Storage
        const { data, error } = await supabase
            .storage
            .from(bucketName)
            .upload(filePath, blob, {
                contentType: contentType,
                upsert: true, // Optional: overwrites existing file with same path
            });

        if (error) {
            console.error("Error uploading file:", error);
            return { success: false, error };
        }

        return { success: true, data };
    };

    // Function to upload ArrayBuffer to Supabase Storage
    public uploadJsonToSupabase = async (
        data: object,
        bucketName: string,
        filePath: string,
    ): Promise<{ success: boolean; data?: any; error?: any }> => {
        // Convert object to JSON string
        const jsonString = JSON.stringify(data, null, 2); // Pretty-printed with 2-space indentation

        // Create a Blob from the JSON string
        const blob = new Blob([jsonString], { type: "application/json" });

        // Upload the blob to Supabase Storage
        const { data: uploadData, error } = await supabase
            .storage
            .from(bucketName)
            .upload(filePath, blob, {
                contentType: "application/json",
                upsert: true, // Optional: overwrites existing file with same path
            });

        if (error) {
            console.error("Error uploading JSON file:", error);
            return { success: false, error };
        }

        return { success: true, data: uploadData };
    };

    public uploadTextToSupabase = async (
        text: string,
        bucketName: string,
        filePath: string,
    ): Promise<{ success: boolean; data?: any; error?: any }> => {
        // Convert object to JSON string
        const textString = text;

        // Create a Blob from the JSON string
        const blob = new Blob([textString], { type: "application/text" });

        // Upload the blob to Supabase Storage
        const { data: uploadData, error } = await supabase
            .storage
            .from(bucketName)
            .upload(filePath, blob, {
                contentType: "application/text",
                upsert: true, // Optional: overwrites existing file with same path
            });

        if (error) {
            console.error("Error uploading Text file:", error);
            return { success: false, error };
        }

        return { success: true, data: uploadData };
    }
}

export const supabase = SupabaseService.getInstance();
export const supabaseService = new SupabaseService();
